<template>
    <div @click.stop="showMessageOptions = showMessageOptions === message.id ? null : message.id" class="absolute top-5 right-4 inline-block text-left">
        <div>
            <div class="ml-1 text-indigo-500 float-right">
                <svg @focusout="showMessageOptions = null" viewBox="0 0 20 20" fill="currentColor" class="w-6 h-6">
                    <path fill-rule="evenodd" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" clip-rule="evenodd"></path>
                </svg>
            </div>
        </div>


        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div v-show="showMessageOptions === message.id" @focusin.stop="showMessageOptions = message.id" class="origin-top-right absolute right-4 mt-4 w-60 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 z-10" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                <div v-if="type !== 'drafts' && type !== 'trash'" class="py-1">
                    <a v-if="message.read" @click="markUnread" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                        Označit jako nepřečtené
                    </a>
                    <a v-if="!message.read" @click="markRead" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"  d="M2.94 6.412A2 2 0 002 8.108V16a2 2 0 002 2h12a2 2 0 002-2V8.108a2 2 0 00-.94-1.696l-6-3.75a2 2 0 00-2.12 0l-6 3.75zm2.615 2.423a1 1 0 10-1.11 1.664l5 3.333a1 1 0 001.11 0l5-3.333a1 1 0 00-1.11-1.664L10 11.798 5.555 8.835z" clip-rule="evenodd" />
                        </svg>
                        Označit jako přečtené
                    </a>
                </div>
                <div v-if="type !== 'drafts'" class="py-1">
                    <a @click="" :download="'datova zprava ' + message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmID + ' - '+ message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation + '.zfo'" :href="route('download', message.id)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
                        </svg>
                        Stáhnout (.zfo)
                    </a>
                    <a @click="" :download="'datova zprava ' + message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmID + ' - '+ message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation + '.pdf'" :href="route('downloadPdf', message.id)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
                        </svg>
                        Stáhnout (.pdf)
                    </a>
                </div>
                <div v-if="type !== 'drafts'" class="py-1">
                    <a @click="" :download="'dorucenka ' + message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmID + ' - '+ message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation + '.zfo'" :href="route('downloadDeliveryInfoZfo', message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmID)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
                        </svg>
                        Stáhnout doručenku (.zfo)
                    </a>
                    <a @click="" :download="'dorucenka ' + message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmID + ' - '+ message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmAnnotation + '.pdf'" :href="route('downloadDeliveryInfoPdf', message.MessageDownloadResponse.dmReturnedMessage.dmDm.dmID)" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" />
                        </svg>
                        Stáhnout doručenku (.pdf)
                    </a>
                </div>
                <div v-if="type !== 'trash'" class="py-1">
                    <a @click="deleteMessage" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                        </svg>
                        Odstranit
                    </a>
                </div>
                <div v-if="type === 'trash'" class="py-1">
                    <a @click="undelete" href="#" class="group flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900" role="menuitem">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                        </svg>
                        Obnovit
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {useToast} from "vue-toastification";

export default {
    name: "MessagesTableRowOptions",
    props: ['message', 'type'],
    emits: ['refreshMessages'],
    data(){
        return {
            showMessageOptions: false,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    methods: {
        deleteMessage(){
            let url;
            if(this.type === 'drafts') url = route('fapi.deleteDraft', {draftId: this.$props.message.id});
            else url = route('fapi.delete', {msgId: this.$props.message.id});

            axios.delete(url)
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)
                    this.refreshMessages();
                })
                .catch(error => {
                    this.toast.warning('Něco se pokazilo. Zkuste to později.');
                });
        },
        markUnread(){
            axios.post(route('fapi.unread', this.$props.message.id))
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)
                    this.refreshMessages();
                })
                .catch(error => {
                    this.toast.warning('Něco se pokazilo. Zkuste to později.');
                });
        },
        markRead(){
            axios.post(route('fapi.read', this.$props.message.id))
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)
                    this.refreshMessages();
                })
                .catch(error => {
                    this.toast.warning('Něco se pokazilo. Zkuste to později.');
                });
        },
        undelete(){
            axios.post(route('fapi.undelete', this.$props.message.id))
                .then(response => {
                    if(response.status === 200)
                        this.toast.success(response.data.message)

                    this.refreshMessages();
                });
        },
        refreshMessages(manual = 0){
            this.$emit('refreshMessages', manual);
        }
    }
}
</script>

<style scoped>

</style>
